import { API_HOST_MANIFESTEEM } from 'common/config/constants';
import getFbData from '../utils/analytics/getFbData';

export default async (data: {
  email: string;
  value: number;
  currency: string;
  orderId: string;
  userId: string;
  subscriptionId: string;
}): Promise<void> => {
  const { fbp, fbc } = getFbData();

  await fetch(`${API_HOST_MANIFESTEEM}/api/analytics/capi/facebook`, {
    method: 'POST',
    body: JSON.stringify({
      ...data,
      fbp,
      fbc,
    }),
  });
};
